import React from "react";
import investmentImage from "../img/Home.jpg";

const Investment = () => (
  <section id="investment" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
    <div className="text-center max-w-4xl w-full bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 my-4 sm:my-0">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Investment Properties</h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl mb-6 sm:mb-8">St. Louis and Surrounding Missouri Counties</h2>
      <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8">Comprehensive Investment Property Services</p>
      <div className="flex flex-col md:flex-row items-start justify-between gap-6">
        <ul className="text-base sm:text-lg md:text-xl list-disc list-inside text-left md:w-1/2 order-2 md:order-1">
          <li>Single-family and multi-family investment properties</li>
          <li>Multi-tenant investment properties</li>
          <li>Property valuation and market analysis</li>
          <li>Investment strategy and portfolio assistance</li>
        </ul>
        <img src={investmentImage} alt="Investment Properties" className="w-full md:w-1/2 h-auto rounded-lg shadow-md order-1 md:order-2" />
      </div>
      <p className="text-base sm:text-lg md:text-xl mt-6 sm:mt-8"><span className="font-bold">Driscoll Co. RealEstate Services</span> — tailored investment property services since 2004.</p>
    </div>
  </section>
);

export default Investment;
